<template>
  <el-dialog
    append-to-body
    width="800px"
    title="账号数量详情"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table :data="table.data" style="width: 100%" max-height="500">
      <el-table-column type="index" width="50" label="序号"> </el-table-column>
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="account" label="账号"> </el-table-column>
      <el-table-column prop="code" label="邀请码"> </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="160"> </el-table-column>
      <el-table-column prop="create_time" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="showPass(row)">修改密码</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="handleDelete(row)" style="margin-left:10px">
            <el-button slot="reference" type="text" size="mini" style="color: #f56c6c;">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination__wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="table.params.page"
        :page-size="table.params.count"
        :total="table.total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <password ref="pass"></password>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import Password from "./Passwordplus.vue";
export default {
  name: "InviteDetail",
  mixins: [mixinTable],
  components: {Password,},
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.getTable();
    },
    getTable() {
      let _params = {
        ...this.table.params,
        id: this.info.id,
      };
      this.$http
        .get("/admin/flex_agency/account", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handleDelete(row) {
      this.$http
        .post("/admin/flex_agency/deleteAccount", { id: row.id })
        .then((res) => {
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getTable();
          }
        });
    },
    showPass(row) {
      let dom = this.$refs.pass;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
  },
};
</script>
